import { lazy } from 'react'

export const FeelingsVariant2 = lazy(() => import('./FeelingsVariant2'))
